import { Button } from 'antd'
import useTranslation from '@/hooks/useTranslation'

import InfoCircle from '../../svgs/InfoCircle'

const Label = ({ label, error, buttonClick }) => {
  const { t } = useTranslation()
  return (
    <div className='flex justify-between mb-8'>
      <label className='flex gap-8 mb-0' htmlFor='email'>
        {t(label)}{' '}
        <InfoCircle style={!error ? 'opacity-0' : ''} color='#D93F21' />
      </label>
      {buttonClick && (
        <Button className='btn-text-green text-sm' onClick={buttonClick}>
          {t('Edit')}
        </Button>
      )}
    </div>
  )
}

export default Label
